export const initialState = {
    active: false,
  };
  
  const spinnerReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SET_ACTIVE_SPINNER":
        return {
          ...state,
          active: action.active,
        };
      default:
        return state;
    }
  };
  
  export default spinnerReducer;
  